import offerLinkSlugified from '@utils/links/offerLinkSlugified'
import offerLinkBuySlugified from '@utils/links/offerLinkBuySlugified'
import { makeOfferCatalogName } from './makeOfferCatalog'

const HOST = process.env.NEXT_PUBLIC_HOST

// Lista wyników: kolejność i adresy ogłoszeń na stronie (dane ogłoszenia na jego stronie).
export function makeItemListLdSchema (ads, query) {
    if (!Array.isArray(ads) || !ads.length) return null
    return {
        "@type": "ItemList",
        "name": `Oferty ${makeOfferCatalogName(ads[0].type, query)}`.trim(),
        "numberOfItems": ads.length,
        "itemListElement": ads.map((ad, i) => {
            const isBuy = ad.type === 'buy_ad' || ad.isBuy
            const link = isBuy ? offerLinkBuySlugified(ad) : offerLinkSlugified(ad)
            return {
                "@type": "ListItem",
                "position": i + 1,
                "url": `${HOST}${decodeURIComponent(link)}`,
            }
        }),
    }
}
